<p-toast position="top-right"></p-toast>

<div class="login-shell">

  <div class="login-brand">
    <div class="brand-orbs" aria-hidden="true">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>

    <div class="brand-header">
      <div class="brand-logo">
        <img src="assets/manager-favicon.svg" alt="iManager" />
        <span class="brand-name"><span class="brand-i">i</span>Manager</span>
      </div>
    </div>

    <div class="brand-inner">
      <div class="brand-copy">
        <h2 class="brand-title">Esqueceu sua<br>senha?</h2>
        <p class="brand-subtitle">
          Redefina sua senha em poucos passos e volte a acessar o portal.
        </p>
      </div>

      <ul class="brand-features">
        <li>
          <div class="feature-icon"><i class="pi pi-shield"></i></div>
          <div class="feature-text">
            <strong>Processo Seguro</strong>
            <span>Confirmamos com um código enviado por e-mail</span>
          </div>
        </li>
        <li>
          <div class="feature-icon"><i class="pi pi-refresh"></i></div>
          <div class="feature-text">
            <strong>Nova Senha</strong>
            <span>Crie uma senha nova e segura</span>
          </div>
        </li>
        <li>
          <div class="feature-icon"><i class="pi pi-check-circle"></i></div>
          <div class="feature-text">
            <strong>Acesso Imediato</strong>
            <span>Volte ao portal com sua nova senha</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="brand-footer">
      <span>© 2026 iManager — Portal de Gestão</span>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="login-card">

      <div class="card-logo-mobile" aria-hidden="true">
        <img src="assets/manager-favicon.svg" alt="iManager" />
      </div>

      <!-- Step indicator (4 passos — ux.md §3.2) -->
      <div class="step-indicator">
        <div class="step-dot" [class.active]="step >= 1" [class.done]="step > 1">
          <span *ngIf="step <= 1">1</span>
          <i *ngIf="step > 1" class="pi pi-check"></i>
        </div>
        <div class="step-line" [class.done]="step > 1"></div>
        <div class="step-dot" [class.active]="step >= 2" [class.done]="step > 2">
          <span *ngIf="step <= 2">2</span>
          <i *ngIf="step > 2" class="pi pi-check"></i>
        </div>
        <div class="step-line" [class.done]="step > 2"></div>
        <div class="step-dot" [class.active]="step >= 3" [class.done]="step > 3">
          <span *ngIf="step <= 3">3</span>
          <i *ngIf="step > 3" class="pi pi-check"></i>
        </div>
        <div class="step-line" [class.done]="step > 3"></div>
        <div class="step-dot" [class.active]="step >= 4">
          <span>4</span>
        </div>
      </div>

      <!-- Passo 1: identificador OU e-mail (D9) -->
      <ng-container *ngIf="step === 1 && !otpCode.showEmpresaPanel">
        <div class="card-headline">
          <h1>Recuperar senha</h1>
          <p>Informe seu identificador <strong>ou</strong> e-mail corporativo — não precisa dos dois.</p>
        </div>

        <form [formGroup]="otpCode.step1Form" (ngSubmit)="otpCode.solicitarCodigo()" class="login-form">

          <div class="field-group">
            <label class="field-label" for="identificador">Identificador único</label>
            <div class="form-field" [class.disabled]="otpCode.step1Form.controls.identificador.disabled">
              <div class="input-wrapper">
                <i class="pi pi-user input-icon" aria-hidden="true"></i>
                <input
                  pInputText
                  id="identificador"
                  placeholder="Digite seu identificador"
                  type="text"
                  maxlength="64"
                  formControlName="identificador"
                  autocomplete="username" />
              </div>
            </div>
          </div>

          <div class="mc-divider"><span>ou</span></div>

          <div class="field-group">
            <label class="field-label" for="email">E-mail corporativo</label>
            <div class="form-field" [class.disabled]="otpCode.step1Form.controls.email.disabled">
              <div class="input-wrapper">
                <i class="pi pi-envelope input-icon" aria-hidden="true"></i>
                <input
                  pInputText
                  id="email"
                  placeholder="seu@empresa.com"
                  type="email"
                  formControlName="email"
                  autocomplete="off" />
              </div>
            </div>
            <span class="field-hint" *ngIf="otpCode.step1Form.controls.email.disabled">
              Deixe em branco se já preencheu o campo acima.
            </span>
          </div>

          <div class="login-error" role="alert" *ngIf="errorMessage">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <button
            pButton
            type="submit"
            label="Enviar código"
            class="login-btn"
            [disabled]="!otpCode.step1PodeEnviar || otpCode.loading"
            [loading]="otpCode.loading">
          </button>

          <div class="form-link-row">
            <a class="form-link" (click)="voltarAoLogin()" href="javascript:void(0)">
              <i class="pi pi-arrow-left"></i> Voltar ao login
            </a>
          </div>

        </form>
      </ng-container>

      <!-- Sub-estado do Passo 1: escolha de empresa (ux.md §5.12) -->
      <ng-container *ngIf="step === 1 && otpCode.showEmpresaPanel && !otpCode.empresaPanelExpirado">
        <div class="card-headline">
          <h1 tabindex="-1" appFocusOnInit aria-live="polite">Selecione a empresa</h1>
          <p>Encontramos mais de uma empresa associada a esse dado. Escolha para onde enviar o código.</p>
        </div>

        <app-otp-empresa-selecao
          [empresas]="otpCode.empresasCandidatas"
          [loadingRef]="otpCode.empresaLoadingRef"
          [errorMessage]="otpCode.empresaErrorMessage"
          (escolher)="otpCode.escolherEmpresa($event)"
          (voltar)="otpCode.voltarDoPainelEmpresa()"
        ></app-otp-empresa-selecao>

        <p class="countdown-hint">Essa escolha expira em {{ otpCode.formatMMSS(otpCode.escolhaSegundosRestantes) }}</p>
      </ng-container>

      <!-- Sub-estado do Passo 1: escolha de empresa expirada (ux.md §5.12-A) -->
      <ng-container *ngIf="step === 1 && otpCode.showEmpresaPanel && otpCode.empresaPanelExpirado">
        <div class="card-headline">
          <h1 tabindex="-1" appFocusOnInit aria-live="polite">Essa escolha expirou</h1>
          <p>
            Por segurança, a seleção de empresa expira depois de alguns minutos. Solicite um novo
            código para continuar.
          </p>
        </div>

        <button
          pButton
          type="button"
          label="Voltar e solicitar novo código"
          class="login-btn"
          (click)="otpCode.voltarEscolhaExpirada()">
        </button>
      </ng-container>

      <!-- Passo 2: código de confirmação (NOVO) -->
      <ng-container *ngIf="step === 2 && !otpCode.otpExpirado && !otpCode.otpBloqueado">
        <div class="card-headline">
          <h1>Confirme seu e-mail</h1>
          <p>Enviamos um código de 6 dígitos para o e-mail associado a esse cadastro.</p>
        </div>

        <form class="login-form" (ngSubmit)="otpCode.confirmarCodigo()">

          <app-otp-input
            [disabled]="otpCode.otpVerificando || otpCode.otpConfirmado"
            [invalid]="otpCode.otpInvalido"
            [success]="otpCode.otpConfirmado"
            (userInput)="otpCode.onOtpUserInput()"
            (codeComplete)="otpCode.onOtpCodeComplete($event)"
          ></app-otp-input>

          <p class="countdown-hint">
            O código expira em {{ otpCode.formatMMSS(otpCode.otpSegundosRestantes) }}
          </p>
          <p class="sr-only" role="status" aria-live="polite" *ngIf="otpCode.avisoExpiracaoProxima">
            Atenção: o código expira em menos de 1 minuto.
          </p>

          <p class="confirmado-hint" role="status" aria-live="polite" *ngIf="otpCode.otpConfirmado">
            ✓ E-mail confirmado: {{ otpCode.destinoMascarado }}
          </p>

          <div class="reenvio-row">
            <span>Não recebeu?</span>
            <!-- ux.md §5.10: com a cota esgotada o link CONTINUA visível, só
                 desabilitado — não sai da tela (não é troca de painel). -->
            <a
              class="form-link"
              [class.disabled]="!otpCode.otpReenvioPermitido"
              [attr.aria-disabled]="!otpCode.otpReenvioPermitido ? 'true' : null"
              (click)="otpCode.reenviarCodigo()"
              href="javascript:void(0)">
              {{ otpCode.otpReenvioLabel }}
            </a>
            <span class="reenvio-hint" *ngIf="otpCode.otpReenvioCotaEsgotada">
              Limite de reenvios atingido
            </span>
          </div>

          <div class="login-error" role="alert" *ngIf="errorMessage">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <button
            pButton
            type="submit"
            label="Confirmar"
            class="login-btn"
            [disabled]="!otpCode.otpPodeConfirmar"
            [loading]="otpCode.otpVerificando">
          </button>

          <div class="form-link-row">
            <a class="form-link" (click)="otpCode.tentarOutraEntrada()" href="javascript:void(0)">
              <i class="pi pi-arrow-left"></i> Tentar com outro e-mail ou identificador
            </a>
          </div>

        </form>
      </ng-container>

      <!-- Passo 2: código expirado — CTA volta ao passo 1 (não reenvia: o desafio já está
           morto no backend, ux.md §5.7) -->
      <ng-container *ngIf="step === 2 && otpCode.otpExpirado">
        <div class="card-headline">
          <h1 tabindex="-1" appFocusOnInit aria-live="polite">Esse código expirou</h1>
          <p>
            Por segurança, o código enviado por e-mail expira depois de alguns minutos. Solicite um
            novo para continuar.
          </p>
        </div>

        <button
          pButton
          type="button"
          label="Solicitar novo código"
          class="login-btn"
          (click)="otpCode.reenviarAposExpiracao()">
        </button>
      </ng-container>

      <!-- Passo 2: tentativas esgotadas -->
      <ng-container *ngIf="step === 2 && otpCode.otpBloqueado">
        <div class="card-headline">
          <h1 tabindex="-1" appFocusOnInit aria-live="polite">Limite de tentativas atingido</h1>
          <p>
            Por segurança, bloqueamos este código depois de várias tentativas incorretas. Solicite um
            novo código para continuar.
          </p>
        </div>

        <button
          pButton
          type="button"
          label="Solicitar novo código"
          class="login-btn"
          (click)="otpCode.solicitarNovoCodigoAposBloqueio()">
        </button>
      </ng-container>

      <!-- Passo 3: Nova senha -->
      <ng-container *ngIf="step === 3">
        <div class="card-headline">
          <h1>Código confirmado!</h1>
          <p>Crie uma nova senha para o seu acesso.</p>
        </div>

        <form [formGroup]="step3Form" (ngSubmit)="redefinirSenha()" class="login-form">

          <div class="field-group">
            <label class="field-label" for="novaSenha">Nova senha</label>
            <div class="form-field" [class.invalid]="step3Form.controls.novaSenha.invalid && step3Form.controls.novaSenha.touched">
              <div class="input-wrapper">
                <i class="pi pi-lock input-icon" aria-hidden="true"></i>
                <input
                  pInputText
                  id="novaSenha"
                  placeholder="Insira sua nova senha"
                  [type]="showNovaSenha ? 'text' : 'password'"
                  formControlName="novaSenha"
                  autocomplete="new-password" />
                <button
                  type="button"
                  class="icon-btn"
                  [attr.aria-label]="showNovaSenha ? 'Esconder senha' : 'Mostrar senha'"
                  (click)="toggleNovaSenha()">
                  <i class="pi" [ngClass]="showNovaSenha ? 'pi-eye-slash' : 'pi-eye'"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label" for="confirmarSenha">Confirmar senha</label>
            <div class="form-field" [class.invalid]="(step3Form.controls.confirmarSenha.invalid && step3Form.controls.confirmarSenha.touched) || (step3Form.errors?.['senhasDivergentes'] && step3Form.controls.confirmarSenha.touched)">
              <div class="input-wrapper">
                <i class="pi pi-lock input-icon" aria-hidden="true"></i>
                <input
                  pInputText
                  id="confirmarSenha"
                  placeholder="Repita a nova senha"
                  [type]="showConfirmarSenha ? 'text' : 'password'"
                  formControlName="confirmarSenha"
                  autocomplete="new-password" />
                <button
                  type="button"
                  class="icon-btn"
                  [attr.aria-label]="showConfirmarSenha ? 'Esconder senha' : 'Mostrar senha'"
                  (click)="toggleConfirmarSenha()">
                  <i class="pi" [ngClass]="showConfirmarSenha ? 'pi-eye-slash' : 'pi-eye'"></i>
                </button>
              </div>
            </div>
            <span class="field-hint" *ngIf="step3Form.errors?.['senhasDivergentes'] && step3Form.controls.confirmarSenha.touched">
              As senhas não coincidem.
            </span>
          </div>

          <app-senha-checklist [senha]="step3Form.controls.novaSenha.value"></app-senha-checklist>

          <div class="login-error" role="alert" *ngIf="errorMessage">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <button
            pButton
            type="submit"
            label="Redefinir senha"
            class="login-btn"
            [disabled]="step3Form.invalid || loading"
            [loading]="loading">
          </button>

        </form>
      </ng-container>

      <!-- Passo 4: Confirmação -->
      <ng-container *ngIf="step === 4">
        <div class="card-headline success-headline">
          <div class="success-icon">
            <i class="pi pi-check-circle"></i>
          </div>
          <h1>Senha redefinida com sucesso!</h1>
          <p>Você já pode fazer login com sua nova senha.</p>
        </div>

        <button
          pButton
          type="button"
          label="Ir para login"
          class="login-btn"
          (click)="irParaLogin()">
        </button>

      </ng-container>

    </div>
  </div>

</div>
